// Executive Hangar card presets — per-station card options.
// Click a chip → dialog opens with the station's specific card list as a
// dropdown plus a "minutes remaining" timer input (default 30 min).

export const PRESETS = [
  {
    id: "pyam-3-4",
    source: "PYAM 3-4",
    cardOptions: ["Red Supervisor 3-4"],
    defaultMinutes: 30,
  },
  {
    id: "pyam-3-5",
    source: "PYAM 3-5",
    cardOptions: ["Red Supervisor 3-5"],
    defaultMinutes: 30,
  },
  {
    id: "checkmate",
    source: "Checkmate Station",
    cardOptions: [
      "Blue Security Card 1",
      "Blue Security Card 2",
      "Blue Security Card 3",
      "Blue Security Card 4",
      "Board 1",
      "Board 2",
      "Board 3",
    ],
    defaultMinutes: 30,
  },
  {
    id: "orbituary",
    source: "Orbituary Station",
    cardOptions: ["Blue Security Card 1", "Blue Security Card 2", "Board 4", "Board 7"],
    defaultMinutes: 30,
  },
  {
    id: "ruin",
    source: "Ruin Station",
    cardOptions: ["Crypt", "Wasteland", "Last Resort", "Board 5", "Board 6"],
    defaultMinutes: 30,
  },
];

// Quick lookup: source string → preset (used when editing existing cards).
export const PRESET_BY_SOURCE = PRESETS.reduce((acc, p) => {
  acc[p.source] = p;
  return acc;
}, {});
